import { debug } from '../app';
export class Scroll {
    private lenis: any;

    constructor() {
        if (!(navigator.userAgent.includes('Safari') && 'ontouchstart' in window)) {
            // const Lenis: any = require('../plugins/lenis.js');

            // this.lenis = new Lenis({
            //     duration: 1.9,
            //     easing: (t:number) => (t === 1 ? 1 : 1 - Math.pow(2, -10 * t)),
            //     smooth: true,
            //     direction: 'vertical',
            // });

            // requestAnimationFrame(this.scrollFn);
            this.lenis = false;
        } else {
            this.lenis = false;
        }

        debug ? console.log('Scroll initialized') : null;
    }

    private scrollFn = (time: number):void => {
        this.lenis.raf(time);
        requestAnimationFrame(this.scrollFn);
    }

    public handleLiftUp = (target: HTMLElement[] | null):void => {
        if (target) {
            target.forEach((el) => {
                el.addEventListener('click', (e) => {
                e.preventDefault();
                if (this.lenis) {
                    this.lenis.scrollTo(0);
                    } else {
                        window.scrollTo(0, 0);
                    }
                });
            });
        }
    }

    public handleScrollTo = (target: HTMLElement | number): void  => {
        debug ? console.log('scrolling to', target) : null;
        if (target instanceof HTMLElement) {
            target.addEventListener('click', (e) => {
                e.preventDefault();
                const targetId = target.getAttribute('href');
                if (this.lenis) {
                    this.lenis.scrollTo((document.querySelector(targetId) as HTMLElement).offsetTop);
                } else {
                    window.scrollTo(0, (document.querySelector(targetId) as HTMLElement).offsetTop);
                }
            });
        } else {
            if (this.lenis) {
                this.lenis.scrollTo(target);
            } else {
                window.scrollTo(0, target);
            }
        }
    }
}